import { combineReducers } from 'redux';

import byId from './byId/reducer';
import byPage from './byPage/reducer';
import paging from './paging/reducer';
import emojis from './emojis/reducer';
import creation from './creation/reducer';

export default combineReducers({
  byId,
  byPage,
  paging,
  emojis,
  creation
});





/** WEBPACK FOOTER **
 ** ./src/members/state/journal/reducer.js
 **/